module.exports = "/images/logo.png?5e2df8195eb15c0f722f30e8a843c3b5";